// ========================================================
// FAST HIT Website — Firebase Configuration
// ========================================================

import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyDXF_NLzzGP14VtltK5B5p-QZ-wby6Kbwg',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'fast-hit-app.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'fast-hit-app',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'fast-hit-app.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '720531319590',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:720531319590:web:386048ae56cf98388d6fe7',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);
export const db = getFirestore(app);
export const rtdb = getDatabase(
  app,
  import.meta.env.VITE_FIREBASE_DATABASE_URL ||
    'https://fast-hit-app-default-rtdb.firebaseio.com',
);

// Connect to emulators in development if explicitly enabled
if (import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true') {
  try {
    connectAuthEmulator(auth, 'http://localhost:9099');
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectDatabaseEmulator(rtdb, 'localhost', 9000);
  } catch (err) {
    console.warn('Could not connect to Firebase emulators:', err);
  }
}

export default app;
